import React, { useEffect, useState } from "react";
import { Grid, Button } from "@material-ui/core";
import Controls from "../../../controls/Controls";
import { useForm, Form } from "../../../controls/useForm";
import { request } from "../../../../api/Service";
import { store } from "../../../../redux-store/store";
import { toast } from "react-toastify";

const returnables = () => [
  { id: "true", title: "true" },
  { id: "false", title: "False" },
];

const initialFValues = {
  id: 0,
  categoryId: "",
  productName: "",
  unit: "",
  productDescription: "",
  sku: "",
  returnable: "",
};

export default function AddProductForm(props) {
  const { addOrEdit, recordForEdit, categories } = props;
  const [file, setFile] = useState(null);
  const [imageText, setImageText] = useState("No Image Selected!");
  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    if ("productName" in fieldValues)
      temp.productName = fieldValues.productName
        ? ""
        : "This field is required.";
    if ("unit" in fieldValues)
      temp.unit = fieldValues.unit ? "" : "This unit is required.";
    if ("sku" in fieldValues)
      temp.sku = fieldValues.sku ? "" : "This sku is required.";
    if ("productDescription" in fieldValues)
      temp.productDescription = fieldValues.productDescription
        ? ""
        : "This productDescription is required.";
    if ("categoryId" in fieldValues)
      temp.categoryId =
        fieldValues.categoryId !== "" ? "" : "Select a Category";
    setErrors({
      ...temp,
    });
    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  var get_product = (sku) =>
    request("get", {}, `api/Admin/get-product/${sku}`).then((data) => {
      if (data.companyId > 0) {
        toast.success("Product does Exist");
      }
    });

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, true, validate, get_product);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      var data = { ...values, formFile: file, basePrice: 0 };
      addOrEdit(data, resetForm);
    }
  };

  const selectFile = (event) => {
    setFile(event.target.files[0]);
    setImageText("Image Uploaded");
  };

  useEffect(() => {
    if (recordForEdit !== null)
      setValues({
        ...recordForEdit,
      });
  }, [recordForEdit]);

  const [holdBtn, setHoldBtn] = useState(true);

  useEffect(() => {
    // Check if all values are filled
    const allValuesFilled = Object.values(values).every(
      (value) => value !== "" && value !== null && value !== undefined
    );

    // Check if file is selected
    if (allValuesFilled) {
      setHoldBtn(false);
    } else {
      setHoldBtn(true);
    }
  }, [values, file]);

  return (
    <Form onSubmit={handleSubmit}>
      <Grid container>
        <Grid item xs={6}>
          <div style={{ position: "relative" }}>
            <Controls.Input
              label="SKU"
              name="sku"
              value={values.sku || ""}
              onChange={handleInputChange}
              error={errors.sku}
            />{" "}
            <i
              style={{ position: "relative", right: "5rem", top: "0.72rem" }}
              className="fas fa-barcode fa-3x"
            ></i>
          </div>
          <Controls.Input
            name="productName"
            label="Product Name"
            value={values.productName || ""}
            onChange={handleInputChange}
            error={errors.productName}
          />
          <Controls.Input
            label="Product Description"
            name="productDescription"
            value={values.productDescription || ""}
            onChange={handleInputChange}
            error={errors.productDescription}
          />
          <Controls.Input
            label="Unit"
            name="unit"
            value={values.unit || ""}
            onChange={handleInputChange}
            error={errors.unit}
          />
        </Grid>
        <Grid item xs={6}>
          <Controls.Select
            name="categoryId"
            label="Categories"
            value={values.categoryId || ""}
            onChange={handleInputChange}
            options={categories}
            error={errors.categoryId}
          />
          <label
            style={{ marginLeft: "10px" }}
            htmlFor="btn-upload"
            className="my-2"
          >
            <input
              id="btn-upload"
              name="btn-upload"
              style={{ display: "none" }}
              type="file"
              accept="image/*"
              onChange={selectFile}
            />
            <Button className="btn-choose" variant="outlined" component="span">
              Choose Image
            </Button>
            {/* notify Image uploaded */}
            {imageText === "No Image Selected!" ? (
              <span className="text-gray-500 italic px-3">{imageText}</span>
            ) : (
              <span className="text-blue-500 italic font-semibold px-3">
                {imageText}
              </span>
            )}
          </label>

          <Controls.Select
            name="returnable"
            label="Returnables"
            value={values.returnable || ""}
            onChange={handleInputChange}
            options={returnables()}
            error={errors.returnable}
          />

          <div>
            <Controls.Button disabled={holdBtn} type="submit" text="Submit" />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
}
